<div class="pinned">
  <div class="title">
    <nb-route-tabset [tabs]="tabs" [fullWidth]="true"></nb-route-tabset>
  </div>
  <div class="buttons">
    <label class="count" *ngIf="booted && count && setting !== Type.ScheduleTimeline">{{ (setting === Type.ScheduleOverview ? 'activeschedules' : 'results') | plural:count | translate:{value: count.toLocaleString()} }}</label>
    <div *ngIf="setting === Type.ScheduleOverview" class="dates">
      <input #rangefieldpicker nbInput fieldSize="medium" [placeholder]="'enterdaterange' | translate" [formControl]="dates" (change)="paged()" [nbDatepicker]="rangepicker">
      <nb-rangepicker #rangepicker></nb-rangepicker>
      <button nbButton [nbPopover]="datePresetTpl" nbPopoverTrigger="click" nbPopoverPlacement="bottom"
              #datePop="nbPopover" [attr.aria-label]="'enterdaterange' | translate">
        <nb-icon icon="arrow-ios-downward"></nb-icon>
      </button>
      <ng-template #datePresetTpl>
        <div class="kebab-popup">
          <button *ngFor="let it of datepresents" class="kebab-item"
                  (click)="applyDatePreset(it.data)">
            {{ it.title }}
          </button>
        </div>
      </ng-template>
    </div>
    <div *ngIf="booted && setting === Type.ScheduleTimeline">
      <button nbButton (click)="datepicker.date = null; dinput.click()"><nb-icon icon="calendar-outline"></nb-icon></button>
      <input nbInput #dinput style="visibility: hidden; width: 0; padding: 0 !important;" [nbDatepicker]="datepicker">
      <nb-datepicker #datepicker (dateChange)="updateCenter($event)"></nb-datepicker>
      <nb-select [formControl]="this.timeline" class="dates">
        <nb-option *ngFor="let t of TimelineTypes" [value]="t">
          {{ t | translate }}
        </nb-option>
      </nb-select>
    </div>
    <button *ngIf="setting !== Type.ScheduleTimeline && setting !== Type.ScheduleOverview" nbButton ghost status="basic" size="small" class="view-toggle"
      [nbTooltip]="(forceCards ? 'viewtable' : 'viewcards') | translate"
      [attr.aria-label]="(forceCards ? 'viewtable' : 'viewcards') | translate"
      (click)="toggleViewMode()">
      <nb-icon [icon]="forceCards ? 'list-outline' : 'grid-outline'"></nb-icon>
    </button>
    <bst-table-options-button *ngIf="setting !== Type.ScheduleTimeline" [count]="filterCount" (open)="dualAxis?.openOptions('filters')"></bst-table-options-button>
    <button *ngIf="canEdit && type === TableType.Clients" nbButton shape="semi-round" size="small" status="primary" (click)="openNewClientDialog()"><nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'add'+type.toString() | translate }}</button>
    <button *ngIf="canEdit && type !== TableType.Clients" nbButton shape="semi-round" size="small" status="primary" [routerLink]="'/'+type.toString()+'/new'"><nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'add'+type.toString() | translate }}</button>
  </div>
</div>
<section>
  <bst-dual-axis *ngIf="setting !== Type.ScheduleTimeline" #dualAxisComponent [export]="setting === Type.ScheduleOverview ? type + '_' + setting : null" [tag]="type + '_' + setting" [delegate]="this" [bootstrap]="true"></bst-dual-axis>
  <bst-timeline-chart *ngIf="setting === Type.ScheduleTimeline" #timelineChartComponent [filter]="this.filters" [loading]="loading" [tabletype]="this.type" [type]="this.timeline.value"></bst-timeline-chart>
  <article *ngIf="sideDefs as sdef" class="search-params" [class.hidden]="!searcher">
    <a (click)="toggleSearcher()" [title]="(searcher ? 'closefilters' : 'showfilters') | translate"><nb-icon [icon]="searcher ? 'arrow-ios-forward' : 'arrow-ios-back'"></nb-icon></a>
    <div class="side-params">
      <div class="inputs">
        <div *ngFor="let d of sdef" [ngStyle]="d.style">
          <ng-container *ngTemplateOutlet="searchParam; context: {d: d}"></ng-container>
        </div>
      </div>
      <div class="buttons">
        <button nbButton type="button" (click)="reset()" status="basic">{{'reset' | translate }}</button>
        <button nbButton type="button" (click)="search()" status="primary">{{ 'search' | translate }}</button>
      </div>
    </div>
  </article>
</section>

<ng-template #searchParam let-d="d">
  <ng-container *ngIf="searchform" [ngSwitch]="d.type" [formGroup]="searchform">
    <label>{{ d.title }}</label>
    <div>
      <ng-container *ngSwitchCase="ColType.RANGE">
        <input nbInput class="input-full-width" [placeholder]="'enterdaterange' | translate" [nbDatepicker]="rangepicker" [formControlName]="d.name">
        <nb-rangepicker #rangepicker></nb-rangepicker>
      </ng-container>
      <nb-select *ngSwitchCase="ColType.SELECT" [formControlName]="d.name" [placeholder]="'select' | translate:{value: d.title}">
        <nb-option *ngFor="let l of d.list" [value]="l.id">
          {{ l.name }}
        </nb-option>
      </nb-select>
      <nb-select *ngSwitchCase="ColType.BOOL" [formControlName]="d.name" [placeholder]="'?' | translate">
        <nb-option [value]="null">{{ '?' | translate }}</nb-option>
        <nb-option [value]="true">{{ 'yes' | translate }}</nb-option>
        <nb-option [value]="false">{{ 'nee' | translate }}</nb-option>
      </nb-select>
      <textarea *ngSwitchCase="ColType.AREA" nbInput [formControlName]="d.name" [maxLength]="d.length" (keypress)="keyup($event)" [placeholder]="'searchplaceholder' | translate:{value: d.subtitle || d.title}"></textarea>
      <input *ngSwitchCase="ColType.INT" nbInput type="number" [formControlName]="d.name" min="0" max="1000000" [step]="d.length || 10" [placeholder]="'enternumber' | translate:{value: d.title}">
      <nb-radio-group *ngSwitchCase="ColType.RADIO" [name]="d.name" [formControlName]="d.name">
        <nb-radio [value]="null">{{ 'any' | translate }}</nb-radio>
        <nb-radio *ngFor="let l of d.list" [value]="l.id">{{ l.name }}</nb-radio>
      </nb-radio-group>
      <bst-list-adder *ngSwitchCase="ColType.SEARCH" [vertical]="true" [target]="d.name" [formControlName]="d.name" [autolist]="true"></bst-list-adder>
      <input *ngSwitchDefault nbInput type="text" [formControlName]="d.name" [placeholder]="'searchplaceholder' | translate:{value: d.title}">
    </div>
  </ng-container>
</ng-template>

<ng-template #headerCellTemplate let-item="row" let-column="column" let-node="node">
  <ng-container [ngSwitch]="column.name">
    <span *ngSwitchDefault>{{ item['s_' + column.name] || null }}</span>
  </ng-container>
</ng-template>

<ng-template #cellTemplate let-item="row" let-column="column" let-node="node" let-isHeader="isHeader">

  <!--  PROJECT -->
  <ng-container *ngIf="(setting === Type.Active || setting === Type.Pending) && type === TableType.Projects" [ngSwitch]="column.name">
    <div *ngSwitchCase="'name'" class="project-name" (click)="preview(item)">
      <nb-user shape="rectangle" [name]="item.name" [color]="item.color" [picture]="Globals.logo(item)"></nb-user>
    </div>
    <span *ngSwitchCase="'start_on'">{{ Globals.fromDateString(item[column.name]) | date:'d MMM y' }}</span>
    <span *ngSwitchCase="'end_on'">{{ Globals.fromDateString(item[column.name]) | date:'d MMM y' }}</span>
    <span *ngSwitchCase="'description'">
      {{ item.description }}
    </span>
    <span *ngSwitchCase="'for_client'">
      {{ item.for_client ? item.for_client.name : null }}
    </span>
    <span *ngSwitchCase="'company'">
      {{ item.company }}
    </span>
    <bst-timeframe-display *ngSwitchCase="'timeline'" [timeframe]="timeframe" [start]="Globals.fromDateString(item.start_on)" [end]="Globals.fromDateString(item.end_on)" [markers]="null"></bst-timeframe-display>

    <div *ngSwitchCase="'skills'">
      <ng-container *ngIf="item.skills?.length">
        <span>{{ item.skills[0]?.name }}</span>
        <span *ngIf="item.skills.length > 1" class="small-label" [nbTooltip]="Globals.makeList(item.skills.slice(1), 'name')">{{ 'andmore' | translate:{value: item.skills.length - 1} }}</span>
      </ng-container>
      <span *ngIf="!item.skills?.length">-</span>
    </div>

    <div *ngSwitchCase="'developments'">
      <ng-container *ngIf="item.developments?.length">
        <span>{{ item.developments[0]?.name }}</span>
        <span *ngIf="item.developments.length > 1" class="small-label" [nbTooltip]="Globals.makeList(item.developments.slice(1), 'name')">{{ 'andmore' | translate:{value: item.developments.length - 1} }}</span>
      </ng-container>
      <span *ngIf="!item.developments?.length">-</span>
    </div>

    <div *ngSwitchCase="'certifications'">
      <ng-container *ngIf="item.certifications?.length">
        <span>{{ item.certifications[0]?.name }}</span>
        <span *ngIf="item.certifications.length > 1" class="small-label" [nbTooltip]="Globals.makeList(item.certifications.slice(1), 'name')">{{ 'andmore' | translate:{value: item.certifications.length - 1} }}</span>
      </ng-container>
      <span *ngIf="!item.certifications?.length">-</span>
    </div>

    <div *ngSwitchCase="'industry'">
      <div *ngIf="(item.industries) as industries">
        <span *ngIf="industries[0]">
          {{ industries[0].name }}
        </span>
        <span *ngIf="industries.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(industries.slice(1), 'name')">{{ 'andmore' | translate:{value: industries.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'member'">
      <div *ngIf="(item.members) as members">
        <ng-container *ngIf="members.length">
          <span>{{ members.length }}</span>
          <span class="small-label" [nbTooltip]="memberList(members)">{{ 'member' | plural:members.length | translate }}&nbsp;&nbsp;</span>
          <span>{{ totalhours(members) }}</span>
          <span class="small-label">{{ 'totalhours' | translate }}</span>
        </ng-container>
      </div>
    </div>

    <span *ngSwitchDefault>{{ item[column.name] || null }}</span>
  </ng-container>



  <!--  USERS  -->
  <ng-container *ngIf="(setting === Type.Active || setting === Type.Pending || setting === Type.Applied) && type === TableType.Users" [ngSwitch]="column.name">

    <div *ngSwitchCase="'name'">
      <nb-user (click)="preview(item)" color="#eee" size="medium" [picture]="Globals.logo(item)" [name]="item.name_first + ' ' + item.name_last"></nb-user>
    </div>

    <a *ngSwitchCase="'username'" [href]="'mailto:' + item.username" target="_blank">
      {{ item.username }}
    </a>

    <span *ngSwitchCase="'user_created_at'">
      {{ item.user_created_at | date:'d MMM y' }}
    </span>
    <span *ngSwitchCase="'created_at'">
      {{ item.created_at | date:'d MMM y' }}
    </span>

    <span *ngSwitchCase="'phone'">{{ item.phone || null }}</span>

    <div *ngSwitchCase="'leave'" class="inline-flex">
      <span *ngIf="lastHoliday(item) as h else other">
        {{ Globals.fromDateString(h.start_on) > this.today ? (Globals.fromDateString(h.start_on) | date:'d MMM y') + (Globals.fromDateString(h.end_on).getTime() !== Globals.fromDateString(h.start_on).getTime() ? ' - ' + (Globals.fromDateString(h.end_on) | date:'d MMM y') : '') :  (Globals.fromDateString(h.start_on) <= today && Globals.fromDateString(h.end_on) >= today ? ('until' | translate:{value: (Globals.fromDateString(h.end_on) | date:'d MMM y')}) : ('noupcomingleave' | translate)) }}
      </span>
      <ng-template #other>{{ 'noupcomingleave' | translate }}</ng-template>
    </div>

    <div *ngSwitchCase="'project'">
      <div *ngIf="(item.projects | sorted:'end_on') as projects">
        <span *ngIf="projects[0]">
          {{ projects[0].name }}
        </span>
        <span *ngIf="projects.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(projects.slice(1), 'name')">{{ 'andmore' | translate:{value: projects.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'industry'">
      <div *ngIf="(item.industries | sorted:'degree') as industries">
        <span *ngIf="industries[0]">
          {{ industries[0].industry?.name }}
        </span>
        <span *ngIf="industries.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(industries.slice(1), 'industry.name')">{{ 'andmore' | translate:{value: industries.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'category'">
      <div *ngIf="(item.categories | sorted:'degree') as categories">
        <span *ngIf="categories[0]">
          {{ categories[0].name }}
        </span>
        <span *ngIf="categories.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(categories.slice(1), 'name')">{{ 'andmore' | translate:{value: categories.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'market'">
      <div *ngIf="(item.markets | sorted:'name') as markets">
        <span *ngIf="markets[0]">
          {{ markets[0].market?.name }}
        </span>
        <span *ngIf="markets.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(markets.slice(1), 'market.name')">{{ 'andmore' | translate:{value: markets.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'language'">
      <div *ngIf="(item.languages | sorted:'fluency') as languages">
        <span *ngIf="languages[0]">
          {{ languages[0].language?.name }}
        </span>
        <span *ngIf="languages.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(languages.slice(1), 'language.name')">{{ 'andmore' | translate:{value: languages.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'degree'">
      <div *ngIf="(item.degrees | sorted) as degrees">
        <span *ngIf="degrees[0]">
          {{ degrees[0].degree?.name }}
        </span>
        <span *ngIf="degrees.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(degrees.slice(1), 'degree.name')">{{ 'andmore' | translate:{value: degrees.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'development'">
      <div *ngIf="(item.developments | sorted:'id') as developments">
        <span *ngIf="developments[0]">
          {{ developments[0].development?.name }}
        </span>
        <span *ngIf="developments.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(developments.slice(1), 'development.name')">{{ 'andmore' | translate:{value: developments.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'skill'">
      <div *ngIf="sortedSkills(item) as skills">
        <span *ngIf="skills[0]">
          {{ skills[0].skill?.name }}
        </span>
        <span *ngIf="skills.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(skills.slice(1), 'skill.name')">{{ 'andmore' | translate:{value: skills.length - 1} }}</span>
      </div>
    </div>

    <div *ngSwitchCase="'certification'">
      <div *ngIf="(item.certifications | sorted:'id') as certifications">
        <span *ngIf="certifications[0]">
          {{ certifications[0].certification?.name }}
        </span>
        <span *ngIf="certifications.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(certifications.slice(1), 'certification.name')">{{ 'andmore' | translate:{value: certifications.length - 1} }}</span>
      </div>
    </div>

    <span *ngSwitchCase="'start_on'">{{ Globals.fromDateString(item.user_to_client?.start_on) | date:'d MMM y' }}</span>
    <span *ngSwitchCase="'end_on'">{{ Globals.fromDateString(item.user_to_client?.end_on) | date:'d MMM y' }}</span>


    <ng-container *ngSwitchCase="'role'" [ngSwitch]="item.user_to_client?.role">
      <span *ngSwitchCase="UserRole.STAFFER">{{ 'staffer' | translate }}</span>
      <span *ngSwitchCase="UserRole.ADMIN">{{ 'admin' | translate }}</span>
      <span *ngSwitchDefault>{{ 'user' | translate }}</span>
    </ng-container>

    <div *ngSwitchCase="'freelancer'" [ngSwitch]="item.user_to_client.freelancer">
      <span *ngSwitchCase="1">{{ 'external' | translate }}</span>
      <span *ngSwitchDefault>{{ 'internal' | translate }}</span>
      <span *ngIf="item.user_to_client.freelancer && item.company" class="label">{{ item.company }}</span>
    </div>

    <div *ngSwitchCase="'capacity'">
      <span *ngIf="item.capacity as c">
        {{ (([c.capacity_sunday, c.capacity_monday, c.capacity_tuesday, c.capacity_wednesday, c.capacity_thursday, c.capacity_friday, c.capacity_saturday] | scheduleDisplay) | async) }}
      </span>
    </div>

    <div *ngSwitchCase="'cv'" class="cv">
      <a *ngIf="cv(item) as cv" (click)="getcv(cv)"><nb-icon icon="attach"></nb-icon>&nbsp;{{ cv.name || ('download' | translate) }}</a>
    </div>

    <span *ngSwitchCase="'birthdate'">{{ Globals.fromDateString(item.birthdate) | date:'d MMM y' }}</span>
    <span *ngSwitchCase="'last_login'">{{ item.last_login | date:'d MMM y, HH:mm' }}</span>

    <span *ngSwitchCase="'seniority'">
      {{ item.user_to_client.seniority ? item.user_to_client.seniority.name || null : null }}
    </span>

    <span *ngSwitchCase="'department'">
      {{ item.user_to_client.department ? item.user_to_client.department.name || null : null }}
    </span>

    <span *ngSwitchCase="'parent_id'">
      {{ item.user_to_client.parent ? item.user_to_client.parent.name_first + ' ' + item.user_to_client.parent.name_last : null }}
    </span>

    <span *ngSwitchCase="'can_travel'">
      <nb-icon *ngIf="item.can_travel" icon="checkmark"></nb-icon>
    </span>

    <span *ngSwitchCase="'offered'">
      {{ (item.user_to_client.offered || 0) | currency:'EUR' }}
    </span>

    <span *ngSwitchCase="'cost'">
      {{ (item.user_to_client.cost || 0) | currency:'EUR' }}
    </span>

    <div *ngSwitchCase="'approve_reject'" class="equalspaced">
      <button nbButton type="button" shape="rectangle" size="tiny"  [nbTooltip]="'approveuser' | translate" [nbTooltipStatus]="'success'" status="primary" (click)="approve(node)">
        <nb-icon [icon]="'checkmark-circle-2-outline'"></nb-icon>
      </button>
      <button nbButton type="button" shape="rectangle" size="tiny" status="danger" [nbTooltip]="'reject' | translate" [nbTooltipStatus]="'danger'" (click)="reject(node)">
        <nb-icon [icon]="'close-circle-outline'"></nb-icon>
      </button>
    </div>

    <!--    <span *ngSwitchCase="'gender'">-->
    <!--      {{ item.gender === UserGender.UNKNOWN && item.gender_other ? item.gender_other : (this.item.gender | translate) }}-->
    <!--    </span>-->

    <span *ngSwitchDefault>{{ item[column.name] || null }}</span>
  </ng-container>

  <!-- Invited -->
  <ng-container *ngIf="setting === Type.Invited && type === TableType.Users" [ngSwitch]="column.name">
    <a *ngSwitchCase="'username'" [href]="'mailto:' + item.username">
      {{ item.username }}
    </a>
    <span *ngSwitchCase="'invited_at'">
      {{ item.invited_at | date:'d MMM y' }}
    </span>
    <span *ngSwitchCase="'invites'">
      {{ item.invites || 0 }}
    </span>
    <span *ngSwitchCase="'created_by'">
      {{ item.created_by_name }}
    </span>
    <span *ngSwitchCase="'created_at'">
      {{ item.created_at | date:'d MMM y' }}
    </span>
    <div *ngSwitchCase="'send_invite'" style="text-align: center">
      <button nbButton type="button" [disabled]="!caninvite(item.invited_at)" size="tiny" status="primary" (click)="invite(node)">
        <nb-icon [icon]="'email-outline'"></nb-icon>{{ column.title | translate }}
      </button>
    </div>
    <div *ngSwitchCase="'revoke_invite'" style="text-align: center">
      <button nbButton type="button" size="tiny" status="danger" (click)="uninvite(node)">
        <nb-icon [icon]="'trash-2-outline'"></nb-icon>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="setting === Type.Invited && type === TableType.Projects" [ngSwitch]="column.name">
    <span *ngSwitchCase="'invited_at'">
      {{ item.invited_at | date:'d MMM y' }}
    </span>
    <span *ngSwitchCase="'invited_by'">
      <span *ngIf="item.created_by">
        {{ item.created_by.name_first + ' ' + item.created_by.name_last }}
      </span>
      <br>
      <a *ngIf="item.created_by?.username" [href]="'mailto:' + item.created_by.username">
        {{ item.created_by.username }}
      </a>
    </span>
    <span *ngSwitchCase="'role'">
      {{ item.project_role?.name }}
    </span>
    <span *ngSwitchCase="'start_on'">{{ Globals.fromDateString(item[column.name]) | date:'d MMM y' }}</span>
    <span *ngSwitchCase="'end_on'">{{ Globals.fromDateString(item[column.name]) | date:'d MMM y' }}</span>
    <div *ngSwitchCase="'dedication'">
      <span>{{ item.dedication || 0 }}</span>
      <span class="small-label" style="margin-left: 2px">hrs</span>
    </div>
    <div *ngSwitchCase="'for_client'">
      <nb-user *ngIf="item.phase?.project?.for_client"  shape="rectangle" [name]="item.phase?.project?.for_client.name" [color]="'#f7f9fc'" [title]="item.phase?.project?.for_client.address" [picture]="Globals.logo(item.phase?.project?.for_client.logo)"></nb-user>
    </div>
    <div *ngSwitchCase="'project'" (click)="preview(item.phase?.project)" class="project-name">
      <div class="color-preview" [style.background]="item.phase?.project?.color"></div>
      <a>{{ item.phase?.project?.name }}</a>
    </div>
    <div *ngSwitchCase="'accept_reject'" class="equalspaced">
      <button nbButton type="button" shape="rectangle" [nbTooltip]="'accept' | translate" [nbTooltipStatus]="'success'" size="tiny" status="primary" (click)="approve_project(node)">
        <nb-icon [icon]="'checkmark-circle-2-outline'"></nb-icon>
      </button>
      <button nbButton type="button" shape="rectangle" size="tiny" status="danger" [nbTooltip]="'reject' | translate" [nbTooltipStatus]="'danger'" (click)="reject_project(node)">
        <nb-icon [icon]="'close-circle-outline'"></nb-icon>
      </button>
    </div>
  </ng-container>

  <!-- CLIENT -->
  <ng-container *ngIf="setting === Type.Active && type === TableType.Clients" [ngSwitch]="column.name">
    <div *ngSwitchCase="'name'">
      <nb-user (click)="preview(item)" class="clickable" shape="rectangle" [class.tenant-root]="item.is_tenant_root" [class.hasurl]="item.url" [name]="item.name" [color]="item.is_tenant_root ? 'var(--teamer-accent)' : '#f7f9fc'" [title]="item.address" [picture]="Globals.logo(item)"></nb-user>
    </div>
    <div *ngSwitchCase="'url'">
      <a *ngIf="item.url" [href]="Globals.url(item.url)" target="_blank">{{ item.url }}</a>
    </div>
    <div *ngSwitchCase="'description'">
      {{ item.description }}
    </div>
    <span *ngSwitchCase="'address'">
      {{ item.address}}
    </span>
    <span *ngSwitchCase="'phone'">
      {{ item.phone }}
    </span>
    <span *ngSwitchCase="'email'">
      {{ item.email }}
    </span>
    <div *ngSwitchCase="'project'">
      <div *ngIf="(item.assigned_projects | sorted:'end_on') as projects">
        <span *ngIf="projects[0]">
          {{ projects[0].name }}
        </span>
        <span *ngIf="projects.length-1 > 0" class="small-label" [nbTooltip]="Globals.makeList(projects.slice(1), 'name')">{{ 'andmore' | translate:{value: projects.length - 1} }}</span>
      </div>
    </div>
    <span *ngSwitchDefault>{{ item[column.name] || null }}</span>
  </ng-container>

  <ng-container *ngIf="setting === Type.Prospects && type === TableType.Clients" [ngSwitch]="column.name">
    <div *ngSwitchCase="'name'">
      <nb-user (click)="editable?.view ? editable.view(node) : null" class="clickable" shape="rectangle" [name]="item.name" color="#f7f9fc"></nb-user>
    </div>
    <span *ngSwitchCase="'prospect_status'" class="prospect-pill" [class]="'pstatus-' + prospectStatusKey(item)">{{ 'rowtype.' + prospectStatusKey(item) | translate }}</span>
    <span *ngSwitchDefault>{{ item[column.name] || null }}</span>
  </ng-container>

  <!-- SCHEDULE OVERVIEW -->
  <ng-container *ngIf="setting === Type.ScheduleOverview" [ngSwitch]="column.name">
    <div *ngSwitchCase="'name'">
      <div *ngIf="type === TableType.Users && item.user" class="farspaced">
        <div>
          <button nbButton [status]="node.expanded ? 'primary' : 'basic'" size="small" shape="round" (click)="openRow(node)"><nb-icon [icon]="node.expanded ? 'arrow-down' : 'arrow-right'"></nb-icon></button>
        </div>
        <nb-user (click)="preview(item.user)" class="clickable" color="#eee" size="medium" [picture]="Globals.logo(item.user)" [name]="item.user.name_first + ' ' + item.user.name_last"></nb-user>
      </div>
      <div *ngIf="type === TableType.Projects && item.project" (click)="preview(item.project)" class="project-name">
        <nb-user (click)="preview(item.project)" class="clickable" shape="rectangle" [color]="item.project.color" size="medium" [picture]="Globals.logo(item.project)" [name]="item.project.name"></nb-user>
      </div>
      <div *ngIf="type === TableType.Clients && item.client">
        <nb-user (click)="preview(item.client)" class="clickable" shape="rectangle" size="medium" [class.tenant-root]="item.client.is_tenant_root" [class.hasurl]="item.client.url" [name]="item.client.name" [color]="item.client.is_tenant_root ? 'var(--teamer-accent)' : '#f7f9fc'" [title]="item.client.address" [picture]="Globals.logo(item.client)"></nb-user>
      </div>
    </div>
    <div *ngSwitchCase="'duration'" [class.nulled]="!item.duration">
      {{ item.duration | round }}
    </div>
    <div *ngSwitchCase="'tracked_amount'" [class.nulled]="!item.tracked_amount">
      {{ (item.tracked_amount || 0) | currency:'EUR' }}
    </div>
    <div *ngSwitchCase="'tracked_scheduled'" [class.nulled]="!item.tracked_scheduled">
      <span *ngIf="item.tracked_scheduled < 1000">{{ (item.tracked_scheduled || 0.0) | percent }}</span>
    </div>
    <div *ngSwitchCase="'tracked_budget'" [class.nulled]="!item.tracked_budget">
      <span *ngIf="item.tracked_budget < 1000">{{ (item.tracked_budget || 0.0) | percent }}</span>
    </div>
<!--    <div *ngSwitchCase="'tracked_value'" class="right" [class.nulled]="!item.tracked_value">-->
<!--      {{ (item.tracked_value || 0) | currency:'EUR' }}-->
<!--    </div>-->
<!--    <div *ngSwitchCase="'tracked_margin'" class="right">-->
<!--      {{ item.tracked_margin !== null && item.duration ? ((item.tracked_margin || 0.0) | percent) : '' }}-->
<!--    </div>-->
    <div *ngSwitchCase="'fte'">
      {{ item.fte | number:'1.2-2' }}
    </div>
    <div *ngSwitchCase="'scheduled'" [class.nulled]="!item.scheduled">
      {{ item.scheduled | round }}
    </div>
    <div *ngSwitchCase="'delta_hours'" [class.nulled]="!item.delta_hours" [class.none]="item.delta_hours !== null && item.delta_hours < 0">
      {{ item.delta_hours | round }}
    </div>
    <div *ngSwitchCase="'percent_filled'" [class.full]="item.percent_filled <= 1.0 && item.percent_filled !== null" [class.none]="item.percent_filled === null || item.percent_filled > 1.0">
      <div class="inline-flex">
        <span *ngIf="item.percent_filled >= 1000" [nbTooltip]="'schedulewithnocapacity' | translate" [nbTooltipStatus]="'danger'"><nb-icon icon="slash" class="none"></nb-icon></span>
        <span *ngIf="item.percent_filled < 1000">{{ (item.percent_filled || 0.0) | percent }}</span>
      </div>
    </div>
    <div *ngSwitchCase="'capacity'" [class.nulled]="!item.capacity">
      {{ (item.capacity || 0.0) | number }}
    </div>
    <div *ngSwitchCase="'offered'" [class.nulled]="!item.offered">
      {{ (item.offered || 0) | currency:'EUR' }}
    </div>
    <div *ngSwitchCase="'cost'" [class.nulled]="!item.cost">
      {{ (item.cost || 0) | currency:'EUR' }}
    </div>
    <div *ngSwitchCase="'margin'">
      {{ item.margin !== null && item.offered ? ((item.margin || 0.0) | percent) : '' }}
    </div>
    <div *ngSwitchCase="'value'" [class.nulled]="!item.value">
      {{ item.value !== null ? ((item.value || 0.0) | currency:'EUR') : '' }}
    </div>
    <div *ngSwitchCase="'num_projects'" [class.nulled]="!item.num_projects">
      {{ item.num_projects }}
    </div>
    <div *ngSwitchCase="'num_members'" [class.nulled]="!item.num_members">
      {{ item.num_members }}
    </div>
    <div *ngSwitchCase="'workingdays'" [class.nulled]="!item.workingdays">
      {{ item.workingdays }}
    </div>
    <div *ngSwitchCase="'holidays'" [class.nulled]="!item.holidays">
      {{ item.holidays }}
    </div>
    <div *ngSwitchCase="'max_score'">
      <bst-score-selector [value]="item.max_score"></bst-score-selector>
    </div>
    <bst-timeframe-display *ngSwitchCase="'timeline'" [timeframe]="timeframe" [start]="Globals.fromDateString(item.start_on)" [end]="Globals.fromDateString(item.end_on)" [markers]="null"></bst-timeframe-display>
    <span *ngSwitchCase="'status'">{{ isHeader ? null : ('userstatus.'+item.status | translate) }}</span>

    <span *ngSwitchDefault>{{ item[column.name] || null }}</span>
  </ng-container>
</ng-template>


<ng-template #openCellTemplate let-item="row" let-column="column" let-node="node">
  <div *ngIf="type === TableType.Users" class="frozen-row" [style.height.px]="80 + Math.max(item.highlights?.cv?.length, item.highlights?.career?.length, item.highlights?.school?.length)*25">
    <div [style.left.px]="dualAxis?.position.scrollLeft" [style.width]="'calc(100% - ' + (dualAxis?.position.scrollLeft || 0) + 'px)'">
      <div *ngIf="formattedHighlights(item) as highlights" class="highlights">
        <div *ngIf="highlights.length">
          <span *ngFor="let h of highlights" [innerHTML]="h"></span>
        </div>
      </div>
      <div class="assignment-buttons">
        <button nbButton type="button" status="basic" size="small" (click)="preview(item)">
          {{ 'viewfullprofile' | translate }}
        </button>
        <button nbButton type="button" status="primary" (click)="openAssignmentDialog(item)" size="small">
          <span>{{ 'assigntoproject' | translate }}</span><nb-icon icon="arrow-circle-right-outline"></nb-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Mobile (#445): stacked card per row. dual-axis renders this instead of the table when
     isMobile + delegate.cardTemplateOutlet. Reuses #cellTemplate per column so each cell
     looks like the table cell, but laid out as Name (sticky-left, prominent) + the rest as
     label:value + the row actions. No horizontal scroll, nothing truncated. -->
<ng-template #cardTemplate let-row="row" let-node="node" let-columns="columns">
  <div class="to-card">
    <div class="to-card-title">
      <ng-container *ngFor="let s of stickyColumnsLeft">
        <ng-container *ngTemplateOutlet="cellTemplate; context: {row: row, column: s, node: node, isHeader: false}"></ng-container>
      </ng-container>
    </div>

    <dl class="to-card-fields">
      <div class="to-card-field" *ngFor="let c of (node.expanded ? columns : (columns | slice:0:4))">
        <dt>{{ c.title | translate }}</dt>
        <dd (click)="toggleCardValue($event)"><ng-container *ngTemplateOutlet="cellTemplate; context: {row: row, column: c, node: node, isHeader: false}"></ng-container></dd>
      </div>
    </dl>

    <button *ngIf="columns.length > 4" type="button" class="to-card-toggle"
            (click)="node.expanded = !node.expanded; $event.stopPropagation()">
      {{ (node.expanded ? 'less' : 'showmore') | translate }}
      <nb-icon [icon]="node.expanded ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
    </button>

    @if (cardHeroKind === 'project') {
      <div class="to-card-footer">
        @if (projectTimeline(row); as tl) {
          @if (tl.show) {
            <div class="to-footer-timeline"
                 [nbTooltip]="'Timeline: ' + tl.pct + '% of project duration elapsed'">
              <span class="to-footer-label">{{ 'projecttimeline' | translate }}</span>
              <div class="to-hero-track"><span class="to-hero-fill" [style.width.%]="tl.pct"></span></div>
              <span class="to-hero-pct">{{ tl.pct }}%</span>
            </div>
          }
        }
        @if (!projectIsActive(row)) {
          <span class="to-hero-status">{{ 'inactive' | translate }}</span>
        }
      </div>
    }

    <!-- Card action buttons removed: the card's name/avatar opens the detail via
         preview() on the name cell (selectRow on the row wrapper is inert in card
         mode except ScheduleOverview+Users). Edit/archive live on the detail page.
         The row was visual clutter and floated at inconsistent heights across cards. -->
  </div>
</ng-template>
